import React, { useState, useEffect } from "react";
import Card from "../Card";
import Div from "../Div";
import SectionHeading from "../SectionHeading";
import Spacing from "../Spacing";
import "./VerticalScrollServices.scss";

const services = [
  { title: "Engineering Design", src: "/images/service_1.jpeg" },
  { title: "Simulations & Analysis", src: "/images/service_2.jpeg" },
  { title: "Rendering & Animations", src: "/images/service_3.jpeg" },
  { title: "Custom Engineering Solutions", src: "/images/service_4.jpeg" },
  { title: "Engineering Design", src: "/images/service_1.jpeg" },
  { title: "Simulations & Analysis", src: "/images/service_2.jpeg" },
  { title: "Rendering & Animations", src: "/images/service_3.jpeg" },
  { title: "Custom Engineering Solutions", src: "/images/service_4.jpeg" },
];

const CARD_WIDTH = 0; // px
const RADIUS = 450;     // px (distance from center - tune this)
const ANGLE_STEP = 360 / services.length;
const isMobile = typeof window !== "undefined" && window.innerWidth <= 700;

export default function VerticalScrollServices() {
  const [focusedIndex, setFocusedIndex] = useState(0);
  const handlePrev = () =>
    setFocusedIndex((prev) => (prev - 1 + services.length) % services.length);

  const handleNext = () =>
    setFocusedIndex((prev) => (prev + 1) % services.length);

  useEffect(() => {
    const interval = setInterval(() => {
      setFocusedIndex((prev) => (prev - 1 + services.length) % services.length);
    }, 4000); // 3000ms = 3 seconds

    return () => clearInterval(interval);
  }, []);


  return (
    <Div className="cs-shape_wrap_4" data-aos="fade-up" data-aos-duration="2000">
      <Div className="cs-shape_4">
        <img src="/images/logo-lixr5.png" alt="Logo" />
      </Div>
      <Div className="cs-shape_4">
        <img src="/images/circle_lixr.png" alt="Logo" />
      </Div>
      <Div className="container">
        <Div className="row">
          {/* Left Side */}
          <Div className="col-xl-4">
            <SectionHeading title="What we offer" subtitle="" />
            <Spacing lg="90" md="45" />
          </Div>
          {/* Right Side */}
          <Div className="col-xl-8" style={{ maxWidth: 800, margin: '0 auto' }}>
            <Div className="carousel-cylinder-container">
              {services.map((item, idx) => {
                const angle = (idx - focusedIndex) * ANGLE_STEP;
                let realAngle = angle;
                if (realAngle > 180) realAngle -= 360;
                if (realAngle < -180) realAngle += 360;
                const isFocused = idx === focusedIndex;
                if (isMobile && !isFocused) return null;
                return (
                <Div
                  key={idx}
                  className={`service-slide${isFocused ? " focused" : ""}`}
                  style={
                    isMobile
                      ? {
                          margin : "50px 0",
                          left: "50%",
                          top: "50%",
                          transform: "translate(-50%, -50%)",
                          width: "86vw",
                          height: "320px",
                        }
                      : {
                          transform: `
                            rotateY(${realAngle}deg)
                            translateZ(${RADIUS}px)
                          `,
                        }
                  }
                >
                  <Card
                    title={item.title}
                    link="/service"
                    src={item.src}
                    alt="Service"
                  />
                </Div>
              );
              })}
            </Div>
            {/* ARROWS: place them in a new container below */}
            <Div className="carousel-arrow-bar">
              <button
                className="carousel-arrow arrow-below"
                onClick={handlePrev}
                aria-label="Previous"
              >
                &#8249;
              </button>
              <button
                className="carousel-arrow arrow-below"
                onClick={handleNext}
                aria-label="Next"
              >
                &#8250;
              </button>
            </Div>
          </Div>
        </Div>
      </Div>
    </Div>
  );
}
